import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import config from 'config'

import useSnackbar from '../Snackbar/useSnackbar'

const useSelectedCarsToBuy = () => {
  const { t } = useTranslation()
  const { showSnackbarMessage } = useSnackbar()

  const [state, setState] = useState({
    isFetching: false,
    cars: [],
    error: null,
  })

  const setStartFetching = useCallback(() => {
    setState((s) => ({
      ...s,
      isFetching: true,
    }))
  }, [setState])

  const setStopFetching = useCallback(
    (error) => {
      setState((s) => ({
        ...s,
        isFetching: false,
        error: error,
      }))
    },
    [setState]
  )

  const setSuccessFetching = useCallback(
    (data) => {
      setState((s) => ({
        ...s,
        isFetching: false,
        ...data,
        error: null,
      }))
    },
    [setState]
  )

  const fetchSelectedCarsToBuy = useCallback(
    async (sessionId, isBlind = false) => {
      setStartFetching()

      try {
        const endpoint = isBlind
          ? 'selected-cars-to-buy-blind'
          : 'selected-cars-to-buy'
        const results = await axios.get(
          `${config.apiBaseUrl}sessions/${sessionId}/${endpoint}`
        )
        setSuccessFetching({ cars: results.data.body })
      } catch (e) {
        let message = t('common.error.fetchData', {
          attribute: e.response?.status,
        })

        setStopFetching(e)

        showSnackbarMessage({
          severity: 'error',
          message,
        })
      }
    },
    [
      setStartFetching,
      setStopFetching,
      setSuccessFetching,
      showSnackbarMessage,
      t,
    ]
  )

  return {
    cars: state.cars,
    isFetching: state.isFetching,
    error: state.error,
    fetchSelectedCarsToBuy,
  }
}

export default useSelectedCarsToBuy
